import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function GoogleAdsPage() {
  return <ServiceDetailLayout slug="google-ads" />;
}
